<template>
  <b-modal
    ref="modal-debt-excel"
    hide-footer
    :title="titleExcel"
    id="modal-debt-excel"
  >
    <b-row class="mb-4">
      <b-col cols="12">
        <b-form-group label="Danh sách cần xuất:">
          <b-form-radio-group v-model="selectedListExcel">
            <b-form-radio value="all">Tất cả các trang</b-form-radio>
            <b-form-radio value="filter">Theo bộ lọc</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-row v-if="selectedListExcel === 'all'">
          <b-col md="4">
            <b-form-group>
              <label>Từ ngày:</label>
              <date-picker
                placeholder="Từ ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.fromDate"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Đến ngày:</label>
              <date-picker
                placeholder="Tới ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.toDate"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-overlay
      :show="isDownloading"
      rounded
      opacity="0.6"
      class="d-inline-block mr-3"
      @hidden="$refs.button.focus()"
    >
      <template #overlay>
        <div class="d-flex align-items-center">
          <b-spinner variant="light" small type="grow"></b-spinner>
        </div>
      </template>
      <b-button variant="primary" size="sm" @click="exportToExcelStream">
        <v-icon small class="text-white" v-b-tooltip>mdi-download</v-icon>
        <strong>Xuất Excel</strong>
      </b-button>
    </b-overlay>

    <b-button
      style="width: 80px"
      variant="secondary"
      size="sm"
      @click="$bvModal.hide('modal-debt-excel')"
    >
      <strong>Hủy</strong>
    </b-button>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { PAYMENT_REF_TYPE } from '@/utils/enum';
import { checkPermissions } from '../../../utils/saveDataToLocal';
import { makeToastFaile } from '../../../utils/common';
import { BASE_URL } from './../../../utils/constants';
import axios from 'axios';
import fileDownload from '../../../utils/file-download';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment';
import { isArray } from 'lodash';
export default {
  props: ['param', 'mode'],
  mixins: [validationMixin],
  data() {
    return {
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      selectedListExcel: 'all',
      apiParams: null,
      titleExcel: 'Xuất excel hoá đơn bán lẻ',
      types: [],
      contactType: null,
      isDownloading: false,
      entityRefType: null,
    };
  },
  components: {
    datePicker,
  },
  computed: {},
  created() {},
  watch: {
    $props: {
      handler() {
        switch (this.mode) {
          case 'items':
            this.titleExcel = 'Công nợ trả góp hoá đơn';
            this.types = [4];
            this.contactType = '3';
            this.entityRefType = PAYMENT_REF_TYPE.BILL;
            break;
          case 'installment-orders':
            this.titleExcel = 'Công nợ trả góp đơn hàng';
            this.types = [4];
            this.contactType = '3';
            this.entityRefType = PAYMENT_REF_TYPE.ORDER;
            break;
          case 'credits':
            this.titleExcel = 'Công nợ quẹt thẻ hoá đơn';
            this.contactType = '5';
            this.types = [3];
            this.entityRefType = PAYMENT_REF_TYPE.BILL;
            break;
          case 'credit-orders':
            this.titleExcel = 'Công nợ quẹt thẻ góp đơn hàng';
            this.types = [3];
            this.contactType = '5';
            this.entityRefType = PAYMENT_REF_TYPE.ORDER;
            break;
          default:
            this.titleExcel = 'Không xác định';
            break;
        }
        this.apiParams = { ...this.param };
      },
      deep: true,
      immediate: true,
    },
  },
  validations: {},
  methods: {
    checkPermissions,
    exportToExcelStream() {
      this.isDownloading = true;

      const baseUrl = BASE_URL;

      const apiParams = this.getParamFilters();

      if (!apiParams) {
        this.isDownloading = false;
        return;
      }

      axios
        .get(`${baseUrl}debts/export-excel`, {
          params: {
            ...apiParams,
          },
          responseType: 'blob',
        })
        .then((response) => {
          const fileName = fileDownload.getFileName(response);
          fileDownload.createFile(response.data, fileName);
          this.isDownloading = false;
        })
        .catch((err) => {
          this.isDownloading = false;
          if (!err.response) {
            // network error
            makeToastFaile('Lỗi!');
          } else {
            const message = err.response.data.message;
            makeToastFaile(message);
          }

          this.$nprogress.done();
        });
    },
    getValuesMultiSelect(arr, prop) {
      return (arr || []).reduce((accumulator, currentValue) => {
        if (currentValue.checked) accumulator.push(currentValue[prop]);
        return accumulator;
      }, []);
    },
    getParamFilters() {
      const DATE_FORMAT = 'DD/MM/YYYY';
      const fromDate = this.apiParams.fromDate
        ? this.apiParams.fromDate
        : '1991-01-01';

      const toDate = this.apiParams.toDate
        ? this.apiParams.toDate
        : moment().format(DATE_FORMAT);

      let contactIds = null;

      if (!isArray(this.apiParams.contactId)) {
        contactIds = this.apiParams.contactId || null;
      } else {
        // contactIds = this.getValuesMultiSelect(
        //   this.apiParams.contactId,
        //   'value'
        // );
        contactIds = this.apiParams.contactId.map(({ value }) => value);
      }

      const apiParams = {
        fromDate: fromDate,
        toDate: toDate,
        types: this.types,
        contactType: this.contactType,
        entityRefType: this.entityRefType,
        contactId: contactIds,
        getFull: true,
      };

      if (this.selectedListExcel === 'filter') {
        const productSearch = this.apiParams.productSearch || '';

        if (productSearch.length < 5 && productSearch.length > 1) {
          makeToastFaile('Tên sản phẩm phải từ 5 kí tự trở lên');
          return null;
        }

        const storeIds = this.getValuesMultiSelect(
          this.apiParams.storeIds,
          'code',
        );
        // if (this.apiParams.storeIds.length) {
        //   const storeIds = this.apiParams.storeIds.map(({ code }) => code);
        // }
        let status = null;
        if (!isArray(this.apiParams.status)) {
          status = this.apiParams.status || null;
        } else {
          status = this.apiParams.status.map(({ value }) => value);
        }

        return {
          ...this.apiParams,
          ...apiParams,
          productSearch: productSearch ? productSearch.trim() : null,
          storeIds: storeIds,
          status,
        };
      }

      return apiParams;
    },
  },
};
</script>
